module.exports = __webpack_public_path__ + "img/icon_1_34.6d156daf.png";